var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"arrow lightboxNext",attrs:{"href":_vm.next}},[_c('i',{staticClass:"fas fa-arrow-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }